import * as React from 'react';
import { DeprecatedEventWrapper } from '../../../../common/analyticsEvents/DeprecatedEventWrapper';
import { IReactTranslateService } from '../../../../common/react/IReactTranslateService';
import { imgPath } from '../../../../common/utilities/ImgUrl';

import { GuidePanel } from '../../components/GuidePanel';


export class AddUserPanel extends React.Component<AddUserPanel.Props, AddUserPanel.State> {

  constructor(props: AddUserPanel.Props) {
    super(props);
  }

  private static imageUrl = imgPath('getting_started_share.png');

  private inviteUserCallback(text: string, content: string) {
    // Deprecated, use TelemetryService instead of AnalyticsEvents.
    this.props.analyticsEvents.sendGettingStartedEvent('invite_others_cta', text, content);
    // We have to pass along a reason when we close a modal, even though we aren't processing it.
    this.props.closeModalFn();
    this.props.$state.go('main.site.users');
  }

  public render(): any {
    const content = this.props.translate('gettingStarted_inviteUsersContent');
    const ctaText = this.props.translate('gettingStarted_inviteUsersCTA_2');
    const callback = () => this.inviteUserCallback(ctaText, content);

    return (
      <GuidePanel
        imgUrl={AddUserPanel.imageUrl }
        content={ content }
        callToActionText={ ctaText }
        callback={ callback }
      />
    );
  }
}

export module AddUserPanel {
  export interface Props {
    translate: IReactTranslateService;
    analyticsEvents: DeprecatedEventWrapper;
    $state: ng.ui.IStateService;
    closeModalFn: () => void;
  }

  export interface State {}
}
